import { UseMutationOptions } from '@tanstack/react-query';

import { CommonSuccess, GenericFailure } from '@playq/services-shared';

import { services2 } from '/api/services2';
import { useEitherMutation } from '/api/service-hooks';

import { MutateChannelPayload } from './types';

export const useDeleteChannel = (
  options?: UseMutationOptions<CommonSuccess, GenericFailure | Error, MutateChannelPayload>
) =>
  useEitherMutation(
    ({ appID, teamId, teamChannel, env }) =>
      services2.teamsChatLookupService.deleteChannel(appID, teamId, teamChannel, env),
    {
      ...options,
    }
  );
